import DefaultFormTemplate from '@/features/requests/components/NewRequest/Templates/DefaultFormTemplate';
import GenesisCareFormTemplate from '@/features/requests/components/NewRequest/Templates/GenesisCareFormTemplate';
import OsuFormTemplate from '@/features/requests/components/NewRequest/Templates/OsuFormTemplate';
import { CollaborationTemplateDto } from '@oncolens/oncolens-ui/lib/dto/event/request';
import { FC } from 'react';
import store, {
  FormValues,
  osuStoreHydrate,
} from '@/features/requests/components/NewRequest/Templates/osu/store';
import useRequestFormStore, {
  genesisStoreHydrate,
  RequestFormStoreValues,
} from '@/features/requests/RequestFormStore';
import { CreatedFormStore } from '@oncolens/oncolens-ui/lib/libraries/FormStore';
import { EventHistoryDto } from '@/features/requests/api/getEventHistories';
import { DiseaseDto } from '@/features/requests/components/NewRequest/Templates/osu/dtos/Event';
import { EpisodeDto } from '@/features/requests/components/NewRequest/Templates/osu/dtos/Episode';
import { FullCollaborationRequestDto } from '@/features/requests/dto/FullCollaborationRequest';
import { RequestDto } from '@oncolens/oncolens-ui/lib/dto/event/request';

const templates: Record<string, FC<any>> = {
  DefaultFormTemplate,
  GenesisCareFormTemplate,
  OsuFormTemplate,
};

export const collaborationTemplateComponentExists = (component?: string) => {
  return component && templates[component];
};

export const getCollaborationTemplateComponent = (
  template: CollaborationTemplateDto | undefined
) => {
  if (template?.component && templates[template.component]) {
    return templates[template?.component];
  }

  return null;
};

export function getStoreByTemplate(
  template?: CollaborationTemplateDto
):
  | [CreatedFormStore<FormValues>, (state: any, data: FullCollaborationRequestDto) => void]
  | [CreatedFormStore<RequestFormStoreValues>, (state: any, data: RequestDto) => void] {
  if (template && template.component === 'OsuFormTemplate') {
    return [store, osuStoreHydrate];
  }

  return [useRequestFormStore, genesisStoreHydrate];
}

export function getLastBiopsyEvent(
  eventHistories?: EventHistoryDto[]
): EventHistoryDto | undefined {
  return getLastEvent(eventHistories, 'Biopsy');
}

export function getLastPathologyEvent(
  eventHistories?: EventHistoryDto[]
): EventHistoryDto | undefined {
  return getLastEvent(eventHistories, 'Pathology');
}

function getLastEvent(
  eventHistories?: EventHistoryDto[], 
  eventType?: string
): EventHistoryDto | undefined {
  if (!eventHistories) {
    return undefined;
  }
  return eventHistories
    .sort((a, b) => {
      if (!b.eventDate) {
        return -1;
      }

      if (!a.eventDate) {
        return 1;
      }
      return b.eventDate.getTime() - a.eventDate.getTime();
    })
    .find((event) => event.eventType === eventType);
}

export function getPrimaryDisease(diseases?: DiseaseDto[]) {
  return diseases?.find((disease) => disease.isPrimary);
}
export function getTargetEpisode(episodes?: EpisodeDto[]) {
  return episodes?.find((episode) => episode.isTargetEpisode);
}
